module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJGbGFnIG9mIFBvbGFuZCIgdmlld0JveD0iMCAwIDE2IDEwIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjEwIiBmaWxsPSIjZmZmIi8+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSI1IiBmaWxsPSIjZGMxNDNjIiB5PSI1Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-country-flags/svg/pl.svg
// module id = QKNj
// module chunks = 1